export default "__VITE_ASSET__xyX4sKmz__"